import cn from "classnames";
import { grantUpsellNow } from "../../../../services/pushUpsaleForApp";
import { withUpsellPaypalId } from "../../../../services/appApi";
import { UpsaleButton } from "../../../../components/UpsaleButton/UpsaleButton";
import { useRegistrationSection } from "../../../../providers/RegistrationSectionProvider/useRegistrationData";
import styles from './UpsaleSecondOffer.module.scss';
import { useNavigate } from "react-router";
import { UpsaleSecondOfferCard } from "../UpsaleSecondOfferCard/UpsaleSecondOfferCard";
import { Title } from "../../../../components/Title/Title";
import { useEffect, useRef, useState } from "react";
import { addSubscriptionUpsale } from "../../../../services/addSubscriptionUpsale";
import { Spinner } from "../../../../components/Spinner/Spinner";
import { useUserData } from "../../../../providers/UserDataProvider/useUserData";
import { loadPaypalSdk, loadPaypalSdkForOrder } from "../../../../services/loadPaypalSdk";
import { getCurrencySymbol } from "../../../../services/getCurrencySymbol";
import { ampPaypalButtonClicked, ampPurchaseAdditional, ampPurchaseStatus } from "../../../../utils/AmplitudeEvents";

export const UpsaleSecondOffer = ({content:data})=>{
  const [activeIdx, setActiveIdx] = useState(0);
  const [message,setMessage] = useState(null);
  const [offerData, setOfferData] = useState(data.offers[0] || null);
  const [loading,setLoading] = useState(false);
  const { nextSlug,sessionInfo } = useRegistrationSection();
  const { userData,setUserData } = useUserData();
  const currency = localStorage.getItem('currency') || 'usd';
  const currencyCode = sessionInfo?.subscription?.currency?.toLowerCase?.() || currency || 'usd';
  const currency_code = currencyCode?.toUpperCase() || 'USD';
  const paypalRef = useRef(null);
  const [containerID, setContainerID] = useState(null)
  const navigate = useNavigate();
  const {title, offers, button} = data;
  useEffect(() => {
    if (!offers || !userData?.upsale) return;
    const unpaidOfferIndex = offers.findIndex(
      (offer) => userData.upsale[offer.upsaleKey] !== 'paid'
    );
  
    if (unpaidOfferIndex !== -1) {
      setActiveIdx(unpaidOfferIndex);
      setOfferData(offers[unpaidOfferIndex]);
    } else {
      navigate(nextSlug);
    }
  }, [offers, userData.upsale]);
const planId = offerData?.paypalID?.[currencyCode] ?? null;
   useEffect(() => {
      let paypalButtons = null;
      if(!containerID) {
        const randomId = Math.random().toString(36).substring(2, 7);
        setContainerID(`paypal-button-${randomId}`);
        return
      }
      function renderButton() {
        if (window.paypal && planId && paypalRef.current) {
          // Очищаем контейнер
          paypalRef.current.innerHTML = "";
          paypalButtons = window.paypal.Buttons({
            style: {
              shape: 'rect',
              color: 'white',
              layout: 'vertical',
              label: 'paypal',
              tagline: false
            },
            createSubscription: function(data, actions) {
              return actions.subscription.create({
                plan_id: planId
              });
            },
            onApprove: function(data, actions) {
              handleSubmit('paypal', data?.subscriptionID);
              ampPurchaseStatus('UpsaleComplete');
              ampPurchaseAdditional({
                currency: currency_code,
                payment_method: 'PayPal',
                price: offerData.paypalPrice/100 || null,
                productId: planId,
                quantity: 1
              })
            },
            onClick: function (data, actions) {
              ampPurchaseStatus('UpsaleStarted');
              ampPaypalButtonClicked(offerData?.title, offerData?.newPrice,currency)
            },
            onCancel : function (data, actions) {
              ampPurchaseStatus('UpsaleDecline');
            },
            onError: function (err) {
              const errorMsg = err?.message || String(err);
              console.error('PayPal error:', errorMsg);
              setMessage(errorMsg);
            }
          });
          paypalButtons.render(`#${containerID}`)
        }
      }
      function renderOneTimeButton() {
        if (window.paypalOrder && offerData.paypalPrice && paypalRef.current) {
          // Очищаем контейнер
          paypalRef.current.innerHTML = "";
  
          paypalButtons = window.paypalOrder.Buttons({
            style: {
              shape: 'rect',
              color: 'white',
              layout: 'vertical',
              label: 'paypal',
              tagline: false
            },
            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [{
                  amount: { value: offerData.paypalPrice/100, currency_code: currency_code },
                  description: "Lifetime Access"
                }]
              });
            },
            onApprove: (data, actions) => {
              return actions.order.capture().then(details => {
                handleSubmit('paypal', details?.id);
                ampPurchaseStatus('UpsaleComplete');
                ampPurchaseAdditional({
                  currency: currency_code,
                  payment_method: 'PayPal',
                  price: offerData.paypalPrice/100,
                  productId: offerData.paypalPrice/100,
                  quantity: 1
                })
              });
            },
            onClick: function (data, actions) {
              ampPurchaseStatus('UpsaleStarted');
              ampPaypalButtonClicked(offerData?.title, offerData?.newPrice,currency)
            },
            onCancel : function (data, actions) {
              ampPurchaseStatus('UpsaleDecline');
            },
            onError: function (err) {
              const errorMsg = err?.message || String(err);
              console.error('PayPal error:', errorMsg);
              setMessage(errorMsg);
            }
          });
          paypalButtons.render(`#${containerID}`)
        }
      }
  
      if(offerData.type==='subscription'){
        loadPaypalSdk(renderButton);
      }else{
        loadPaypalSdkForOrder(currency_code, 
          renderOneTimeButton
        )
      }
  
      
  
      return () => {
        if (paypalButtons) paypalButtons.close();
        if (paypalRef.current) paypalRef.current.innerHTML = "";
      };
    }, [offerData,containerID])
    ;

  if(!data) return;

  const handleSubmit = async (type='stripe', paypalId=null)=>{
    const {priceID,discountID,title,period,newPrice,oldPrice,course_id,upsaleKey} = offerData;
        const {subscription, customer}=sessionInfo;
        setLoading(true);
        const {error } = await addSubscriptionUpsale({
          planID : priceID ||null,
          customerID : customer.id || null,
          discountID : discountID || null,
          title : title || null,
          period : period || null,
          discounted : newPrice / 100,
          subscription : oldPrice / 100,
          currency: subscription.currency || currencyCode,
          userEmail: customer.email
        },type);
        setLoading(false);
        if(error){
          console.error(error)
          setMessage(error)
        }else {
          const updatedUpsale = {
            ...userData.upsale,
            [upsaleKey]: "paid"
          };
      
          setUserData({
            ...userData,
            upsale: updatedUpsale,
            upsalePaypalIDs: withUpsellPaypalId(userData, paypalId),
            upsaleIDs: [
              ...(userData.upsaleIDs || []),
              ...(Array.isArray(course_id) ? course_id : [course_id])
            ]
          });
          await grantUpsellNow(userData, course_id, paypalId);
          const unpaidOffers = offers.filter(offer => updatedUpsale[offer.upsaleKey] !== "paid");
          if (unpaidOffers.length > 0) {
            const nextOffer = unpaidOffers[0];
            const nextIndex = offers.findIndex(o => o.upsaleKey === nextOffer.upsaleKey);
            setActiveIdx(nextIndex);
            setOfferData(nextOffer);
          } else {
            navigate(nextSlug);
          }
        }
  }
  const currencySymbol = getCurrencySymbol(currencyCode);
  return(
    <>
      {loading && <Spinner state={'opacity'} />}
      <div className={styles.wrapper}>
        {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }}/>}
        <div className={styles.offers}>
          {offers.map((offer, idx)=>{
            return(
              <UpsaleSecondOfferCard
                key={idx}
                content={offer}
                currency={currencySymbol}
                status={idx === activeIdx ? "active" : ""}
                paid={userData.upsale?.[offer.upsaleKey] === 'paid' ? true : false}
                onClick={() => {
                  setOfferData(offer);
                  setActiveIdx(idx);
                }}
              />
            )
          })}
        </div>
        {offerData.info && 
          <div className={styles.info}>
            {offerData.info.map((item, idx)=>{
              return(
                <div key={idx} className={styles.infoItem}>{item}</div>
              )
            })}
          </div>
        }
        {message && <div className={styles.message}>{message}</div>}
        {sessionInfo?.subscription?.type ==='paypal' ? <div className={styles.paypal}>
          <div id={containerID} ref={paypalRef}></div>
          </div>:
        <UpsaleButton
          onClick={handleSubmit}
          className={cn(styles.button)}
        >
          {button || "Add to my plan"}
        </UpsaleButton>
        }
      </div>
    </>
  )
}